import { render, staticRenderFns } from "./LocationAdd.vue?vue&type=template&id=590b09ce&"
import script from "./LocationAdd.vue?vue&type=script&lang=js&"
export * from "./LocationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports